import ReactDOM from 'react-dom/client';

import React from 'react';
import { Provider } from 'react-redux';
import App from './App';
import './index.scss';
import { store } from './redux';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
